import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import {
  rootRouteRef,
  projectListRouteRef,
  projectDetailRouteRef,
} from './routes';
import { projOnboardApiRef, ProjOnboardClient } from './api';

export const projOnboardPlugin = createPlugin({
  id: 'proj-onboard',
  routes: {
    root: rootRouteRef,
    projectList: projectListRouteRef,
    projectDetail: projectDetailRouteRef,
  },
  apis: [
    createApiFactory({
      api: projOnboardApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new ProjOnboardClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const ProjOnboardPage = projOnboardPlugin.provide(
  createRoutableExtension({
    name: 'ProjOnboardPage',
    component: () =>
      import('./components/OnboardingPage').then(m => m.OnboardingPage),
    mountPoint: rootRouteRef,
  }),
);

export const ProjOnboardProjectListPage = projOnboardPlugin.provide(
  createRoutableExtension({
    name: 'ProjOnboardProjectListPage',
    component: () =>
      import('./components/ProjectListPage').then(m => m.ProjectListPage),
    mountPoint: projectListRouteRef,
  }),
);

export const ProjOnboardProjectDetailPage = projOnboardPlugin.provide(
  createRoutableExtension({
    name: 'ProjOnboardProjectDetailPage',
    component: () =>
      import('./components/ProjectDetailPage').then(m => m.ProjectDetailPage),
    mountPoint: projectDetailRouteRef,
  }),
);
